import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, editedZoneAction } from '../../reducers/actions';
import { ZoneService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.EDIT_ZONE),
    switchMap(action =>
      ZoneService.update(action.zone, store).pipe(
        map((data) => editedZoneAction(data)),
        catchError(retryAuthentication(action$, 'epics/zones/editZone'))  
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/zones/editZone.js